import { styled } from '@mui/material/styles';
import { default as LinkComponent } from 'components/Link';

export const Link = styled(LinkComponent)(({ theme, selected }) => ({
  alignItems: 'center',
  color: '#206AF5',
  display: 'inline-flex',
  marginTop: theme.spacing(0.5),
  ...(selected && {
    fontWeight: theme.fontWeight.bold
  }),
  height: '100%',
  lineHeight: '100%',
  justifyContent: 'center'
}));

export const ProjectStatusContentContainer = styled('div')(({ theme }) => ({
  borderBottom: '2px solid #000',
  borderTop: '1px solid #cccccc',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  margin: theme.spacing(0, 5, 5)
}));

export const CarouselContainer = styled('div')(() => ({
  borderBottom: '2px solid #000',
  display: 'block',
  height: '100%',
  width: '100%'
}));

export const ProjectStatusTitle = styled('div')(({ theme }) => ({
  fontWeight: theme.fontWeight.bold,
  margin: theme.spacing(5)
}));

export const CandidateCardContainer = styled('div')(({ theme }) => ({
  alignItems: 'center',
  border: `1px solid ${theme.color.grey['400']}`,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  margin: '0 auto',
  position: 'relative',
  width: '80%',
  padding: theme.spacing(2)
}));

export const CandidateEmptyRowPlaceholder = styled('div')(({ theme, longest, long }) => ({
  background: theme.color.background.default,
  borderRadius: '4px',
  height: '16px',
  marginBottom: theme.spacing(2),
  textAlign: 'center',
  width: longest ? '80%' : long ? '65%' : '33%'
}));

export const CandidateEmptyRow = styled('div')(({ theme, longest, long }) => ({
  height: '16px',
  marginBottom: theme.spacing(2),
  width: longest ? '80%' : long ? '65%' : '33%',
  textAlign: 'center'
}));

export const ElectedCandidateContainer = styled('div')(({ theme }) => ({
  margin: theme.spacing(5),
  background: theme.color.background.card
}));

export const RunningCandidateContainer = styled('div')(({ theme }) => ({
  margin: theme.spacing(5),
  background: theme.color.primary.contrast,
  backgroundColor: '#ffffff',
  borderRadius: '4px',
  boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14)',
  maxHeight: '184px'
}));

export const ElectedCandidateCard = styled('div')(({ theme }) => ({
  padding: theme.spacing(5),
  '& .row': {
    display: 'flex',
    flexDirection: 'row',
    width: '100%'
  },
  '& .row.candidate-info': {
    '& img': {
      height: '102px',
      width: '102px'
    },
    '& .content': {
      flexGrow: 1,
      padding: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      '& .title': {
        fontWeight: theme.fontWeight.bold
      }
    }
  },
  '& .row.executiveSummary': {
    padding: `${theme.spacing(5)} 0 0 0`
  },
  '& .row.viewDetails': {
    justifyContent: 'flex-end'
  }
}));

export const MandateRunningContainer = styled('div')(({ theme }) => ({
  margin: theme.spacing(5),
  display: 'flex',
  background: theme.color.background.card,
  '& .candidate-card': {
    width: '100%'
  }
}));

export const PointsContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignContent: 'center',
  alignItems: 'center',
  justifyItems: 'center',
  width: '90px',
  minWidth: '100px'
}));

export const Point = styled('div')(({ color, size }) => ({
  backgroundColor: color,
  borderRadius: '100%',
  width: `${size}px`,
  height: `${size}px`
}));

export const ProjectCardContainer = styled('div')(({ theme }) => ({
  margin: theme.spacing(5),
  width: '40%'
}));

export const ProjectCard = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  padding: theme.spacing(5),
  background: theme.color.primary.contrast,
  backgroundColor: '#ffffff',
  borderRadius: '4px',
  boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14)',
  maxHeight: '184px',
  '& img': {
    height: '102px',
    width: '102px'
  },
  '& .emptyContainer': {
    padding: `0 ${theme.spacing(2)}`,
    flex: 1
  }
}));

export const MandateTerminatedContainer = styled('div')(({ theme }) => ({
  margin: theme.spacing(5),
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'center',
  background: theme.color.background.card,
  '& .candidate-card': {
    minWidth: '40%',
    width: '100%'
  }
}));
